var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFlow = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M3.938 10.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm10.125-4.312a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm0 8.625a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }), _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M12.188 13.313H9.5a.5.5 0 0 1-.5-.5V5.187a.5.5 0 0 1 .5-.5h2.688M5.813 9H9" })] }))); };
export default SvgFlow;
